{
  "pageTitle": "Settings",
  "discord": "Discord",
  "bank": "Bank (ASA)",
  "notifications": "Notifications",
  "channel": "Channel",
  "payment": "Payment",
  "configuredViaEnableDiscord": "Configured via ENABLE_DISCORD",
  "configuredViaDiscordChannel": "Configured via DISCORD_CHANNEL",
  "configuredViaPaymentEnabled": "Configured via PAYMENT_ENABLED",
  "maskedValue": "••••••••",
  "bankNamePlaceholder": "Bank name (e.g. ASA, Procredit)",
  "usernamePlaceholder": "Bank username",
  "passwordPlaceholder": "Bank password",
  "saving": "Saving...",
  "create": "Create",
  "cancel": "Cancel",
  "setDefault": "Set Default",
  "delete": "Delete",
  "onlyBankCannotDelete": "Only bank — cannot delete",
  "edit": "Edit",
  "bankNameInputPlaceholder": "Bank name",
  "update": "Update",
  "usernameKeepPlaceholder": "Current username (leave empty to keep)",
  "currentUsername": "Current username",
  "newPassword": "New password",
  "leaveEmptyToKeep": "leave empty to keep",
  "loading": "Loading...",
  "addBank": "Add Bank",
  "noBanks": "No banks configured yet",
  "noBanksHint": "Add your first bank to enable payments.",
  "bankProviders": "Bank Providers",
  "notificationsConfigured": "Notifications are configured",
  "channelConfigured": "Channel is configured",
  "scrapingSchedule": "Scraping Schedule",
  "scrapingLoading": "Loading...",
  "scrapingSave": "Save",
  "scrapingSaving": "Saving...",
  "scrapingDisable": "Disable Schedule",
  "scrapingLoadError": "Failed to load scraping schedule",
  "scrapingUpdateError": "Failed to update scraping schedule",
  "scrapingDisableError": "Failed to disable scraping schedule",
  "scrapingScheduleDescription": "Triggers every day at the selected time",
  "minInvoiceAmount": "Minimum invoice amount",
  "minInvoiceAmountDescription": "Invoices below this amount are marked as skipped and not paid. Leave empty to disable.",
  "minInvoiceAmountPlaceholder": "e.g. 10.00",
  "scheduleActive": "Active",
  "defaultBank": "Default Bank",
  "deleteConfirmPrompt": "Are you sure you want to delete this address?"
}
